module.exports = __webpack_public_path__ + "e37cf233a89428f9db29520ecfead7a2.mp3";